// resources/client/drive/files/dialogs/AssigneeInterfaceWrapper.tsx

import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';

export function AssigneeInterfaceWrapper() {
  const location = useLocation();
  const navigate = useNavigate();

  // Read from URL query params
  const searchParams = new URLSearchParams(location.search);
  const docId = searchParams.get('docId') || location.state?.documentId;
  const token = searchParams.get('token') || location.state?.token;

  console.log('docID : ',docId);
  console.log('token : ',token);


  const [iframeUrl, setIframeUrl] = useState<string>('');

  useEffect(() => {
    if (!docId || !token) {
      toast.error('Invalid signing link');
      navigate('/');
      return;
    }

    // Construct Assignee Interface URL
    const assigneeBaseUrl = 'http://localhost:5176';
    const fullUrl = `${assigneeBaseUrl}/?mode=sign&docId=${docId}&token=${token}`;

    console.log('🖊️ Loading Signing Interface');
    console.log('   Document ID:', docId);
    console.log('   Token:', token);
    console.log('   Full iframe URL:', fullUrl);

    setIframeUrl(fullUrl);
  }, [docId, token, navigate]);

  useEffect(() => {
    // Listen for messages from iframe
    const handleMessage = (event: MessageEvent) => {
      // Security: Only accept messages from localhost:5176
      if (event.origin !== 'http://localhost:5176') return;

      console.log('📨 Message from Signing Interface:', event.data);

      if (event.data.type === 'SIGNING_COMPLETED') {
        toast.success('Document signed successfully!');
        setTimeout(() => navigate('/documents'), 2000);
      }

      if (event.data.type === 'CANCEL') {
        navigate(-1);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [navigate]);

  if (!iframeUrl) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading signing interface...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <Toaster position="bottom-center" />
      <div className="w-full h-screen bg-gray-100">
        <iframe
          src={iframeUrl}
          className="w-full h-full"
          style={{ border: 'none' }}
          title="Document Signing Interface"
          allow="clipboard-write"
        />
      </div>
    </>
  );
}
